/* Imports */
import APIClient from "../../client";
import { CorrelationToolStartScreen } from "./CorrelationToolStartScreen";
import cropr from "../../../shared/utils/cropr";
import gettext from "../../../shared/utils/gettext";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { DatasetTypes } from "./ObjectInterfaces";

/* Assigning the prop types */
interface CorrelationsViewProps {
  cropfield: any;
  clearMeasurementLayers: any;
  toggleMeasurementLayer: any;
}

/* CorrelationView Component */
export const CorrelationsView = ({
  cropfield,
  clearMeasurementLayers,
  toggleMeasurementLayer,
}: CorrelationsViewProps) => {
  const did: string = cropfield && cropfield.get("did");
  const [datasets, setDatasets] = useState<DatasetTypes[]>([]);
  const [enoughData, setEnoughData] = useState<Boolean>(true);

  /* Collecting the relevant plot data from the database */
  useEffect(() => {
    clearMeasurementLayers();
    setDatasets([]);

    if (!did) return;
    clearMeasurementLayers();

    /* Data Extraction */
    APIClient.post(
      "/api/data/datasets/elasticsearch/_search",
      {
        query: {
          bool: {
            should: [
              {
                term: {
                  "data_set_rois.roi.keyword": did,
                },
              },
            ],
            must_not: [
              {
                terms: {
                  "data_type.keyword": ["soil_type"],
                },
              },
            ],
          },
        },
        size: 1000,
        sort: [
          {
            recording_datetime: "desc",
          },
        ],
      },
      cropr.cloudfarm_oauth_token

      /* Data Processing */
    )
      .then((response: any) => {
        const hits: DatasetTypes[] = response.hits.hits.map((h: { _source: any }) => h._source);

        /* If no hits have been found for this cropfield, no uploaded data exists */
        if (hits.length === 0) {
          setDatasets([]);
          setEnoughData(false);
          return;
        }
        setDatasets(hits);
      })

      .catch((event) => {
        console.error(event);
        cropr.notify("error", gettext("Cannot get Cloudfarm data for this crop field."));
      });
  }, [clearMeasurementLayers, did]);

  /* JSX */
  return datasets.length ? (
    enoughData ? (
      <div className="bg-white p-1">
        <CorrelationToolStartScreen
          clearMeasurementLayers={clearMeasurementLayers}
          datasets={datasets}
          did={did}
          toggleMeasurementLayer={toggleMeasurementLayer}
        />
      </div>
    ) : (
      <div className="bg-white">
        <div className="alert alert-info pt-2 mt-2">
          {gettext("No data was found for this location")}
        </div>
      </div>
    )
  ) : (
    <div className="text-center mt-5 mb-5">
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  );
};
